import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Shield } from 'lucide-react';

function Privacy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Helmet>
        <title>Privacy Policy | Easy Unit Converter</title>
        <meta name="description" content="Our privacy policy explains how we handle your data and protect your privacy." />
      </Helmet>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8 flex items-center gap-3">
          <Shield className="w-8 h-8 text-blue-600" />
          <h1 className="text-4xl font-bold text-gray-900">Privacy Policy</h1>
        </div>

        <div className="prose prose-lg max-w-none">
          <p className="lead">
            At Easy Unit Converter, we take your privacy seriously. This policy explains how we collect,
            use, and protect your personal information.
          </p>

          <h2>Information We Collect</h2>
          <p>
            We collect minimal information to provide and improve our service:
          </p>
          <ul>
            <li>Usage data (conversion types, frequency of use)</li>
            <li>Browser type and version</li>
            <li>Anonymous analytics data</li>
          </ul>

          <h2>How We Use Your Information</h2>
          <p>
            We use the collected information to:
          </p>
          <ul>
            <li>Provide and maintain our service</li>
            <li>Improve user experience</li>
            <li>Analyze usage patterns</li>
            <li>Detect and prevent technical issues</li>
          </ul>

          <h2>Data Storage</h2>
          <p>
            All calculations are performed in your browser. We don't store your conversion data
            on our servers. Recent conversions and favorites are stored locally on your device.
          </p>

          <h2>Cookies</h2>
          <p>
            We use essential cookies to remember your preferences and provide basic functionality.
            Analytics cookies help us understand how visitors use our site.
          </p>

          <h2>Third-Party Services</h2>
          <p>
            We use Google Analytics to understand site usage. This service may collect information
            about your browser and device.
          </p>

          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will notify you of any changes
            by posting the new policy on this page.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have any questions about this privacy policy, please contact us at{' '}
            <a href="mailto:aristomenis.georgiopoulos@gmail.com">aristomenis.georgiopoulos@gmail.com</a>
          </p>
        </div>
      </main>
    </div>
  );
}

export default Privacy;